import { render, staticRenderFns } from "./DisplaySettings.vue?vue&type=template&id=9e0742c6&scoped=true&"
import script from "./DisplaySettings.vue?vue&type=script&lang=js&"
export * from "./DisplaySettings.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySettings.vue?vue&type=style&index=0&id=9e0742c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0742c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCheckbox,VCol,VIcon,VRow})
